import React from "react";
import { withStyles } from "@material-ui/styles";
import { ReactComponent as TickIcon } from "../../assets/icons/rewards/Check.svg";

export const tierTableData = [
  {
    name: "Minimum Shopping Value In A Year",
    insider: "0-49,000",
    silver: "50,000-249,999",
    gold: "2,50,000-499,999",
    platinum: "5,00,000 & above",
  },
  {
    name: "Tenure for Tier Eligibility",
    insider: "1 Year",
    silver: "1 Year",
    gold: "1 Year",
    platinum: "1 Year",
  },
  {
    name: "Loyalty Welcome Points",
    insider: "500",
    silver: "tick",
    gold: "tick",
    platinum: "tick",
  },
  {
    name: "Earn Points on Shopping",
    insider: "1%",
    silver: "2%",
    gold: "2%",
    platinum: "3%",
  },
  {
    name: "Earn 2x Rewards Points on Week Day Shopping",
    insider: "tick",
    silver: "tick",
    gold: "tick",
    platinum: "tick",
  },
  {
    name: "Voucher Redemption",
    insider: "tick",
    silver: "tick",
    gold: "tick",
    platinum: "tick",
  },
  {
    name: "Privilege Sale Preview",
    insider: "N/A",
    silver: "N/A",
    gold: "tick",
    platinum: "tick",
  },
  {
    name: "Discount on Dining (Restaurants Only)",
    insider: "N/A",
    silver: "N/A",
    gold: "10%",
    platinum: "15%",
  },
  {
    name: "Complimentary tea or coffee in-outlet (once a month for 2 @Smoke House Deli",
    insider: "N/A",
    silver: "N/A",
    gold: "N/A",
    platinum: "tick",
  },
  {
    name: "Complimentary Car Parking",
    insider: "N/A",
    silver: "N/A",
    gold: "tick",
    platinum: "tick",
  },
  {
    name: "Eligibility to Invites for Mall Ticketed Events",
    insider: "N/A",
    silver: "N/A",
    gold: "tick",
    platinum: "tick",
    goldSubText: "2 Invites",
    platinumSubText: "4 Invites",
  },
];

const TIER_KEYS = ["insider", "silver", "gold", "platinum"];

const footnotes = [
  "*Tier Eligibility will be the remainder of the current year + 1 calendar year.",
  "*Loyalty Welcome Points is a one-time provision, as an introductory offer.",
  "*Loyalty Points can be redeemed directly in the form of gift vouchers.",
  "*Rewards points can be earned on the net amount of the bills/invoice only (after discounts, if any).",
  "*Terms & Conditions of the dine-in partners will apply.",
  "*Tier benefits on Dine-in cannot be merged or clubbed with any other promotion, scheme, gift vouchers, offer, or discount.",
  "*FC means Food Court.",
  "*Complimentary Car Parking in VIP section is on a first come first served basis.",
  "*Tier-based dine-in benefits shall be limited to a maximum of 10 Pax, and applicable on all calendar days, excluding special events days, (Christmas Day 24th & 25th December) and (New Year's Eve 31st December & 1st January), or any other blackout dates as may be notified by the dine-in partner or Centrio Mall Management from time to time.",
];

const styles = (theme) => ({
  goldGradientBox: {
    position: "relative",
    padding: "3px",
    marginBottom: "10px",
    background:
      "radial-gradient(45.17% 249.6% at 50% 0%, #FCD970 0%, #FCD970 50%, #A77E02 100%),linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
    "& > root": {
      borderRadius: "12px",
      backgroundColor: "#fff",
      padding: "16px",
      width: "100%",
      height: "100%",
    },
  },
  rowName: {
    fontSize: "11px",
    height: "50px",
    fontWeight: "bold",
    fontFamily: '"Playfair Display", sans-serif !important',
    fontStyle: "italic",
    width: "30.33%",
    textAlign: "left",
    padding: "5px",
    color: "#424530",
  },
  insiderCell: {
    fontSize: "11px",
    padding: "10px",
    backgroundColor: "#525045",
    color: "white",
    width: "17%",
    [theme.breakpoints.down("391")]: {
      width: "21%",
    },
  },
  silverCell: {
    fontSize: "11px",
    padding: "10px",
    backgroundColor: "#847F7E",
    color: "white",
    width: "17%",
    [theme.breakpoints.down("391")]: {
      width: "21%",
    },
  },
  goldCell: {
    fontSize: "11px",
    padding: "10px",
    backgroundColor: "#B6997A",
    color: "white",
    width: "17%",
  },
  platinumCell: {
    fontSize: "11px",
    padding: "10px",
    backgroundColor: "#7F8797",
    color: "white",
    width: "17%",
  },
  insiderCellAlt: {
    fontSize: "11px",
    padding: "10px",
    backgroundColor: "#625F51",
    color: "white",
    width: "17%",
  },
  silverCellAlt: {
    fontSize: "11px",
    padding: "10px",
    backgroundColor: "#948E8C",
    color: "white",
    width: "17%",
  },
  goldCellAlt: {
    fontSize: "11px",
    padding: "10px",
    backgroundColor: "#BFA588",
    color: "white",
    width: "17%",
  },
  platinumCellAlt: {
    fontSize: "11px",
    padding: "10px",
    backgroundColor: "#8D96A3",
    color: "white",
    width: "17%",
  },
  tickContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  tickSubText: {
    fontSize: "9px",
    marginTop: "2px",
    color: "white",
    lineHeight: "1.2",
    whiteSpace: "nowrap",
  },
  tableWrapper: {
    borderCollapse: "collapse",
    width: "100%",
    textAlign: "center",
  },
  tableHeader: {
    backgroundColor: "#F4F6F8",
    color: "#424530",
    fontSize: "12px",
    height: "33px !important",
    fontFamily: '"Playfair Display Italic", sans-serif !important',
  },
  tableHeaderCell: {
    height: "33px !important",
  },
  tableRow: {
    borderBottom: "2px solid #ffffff",
  },
  footnotes: {
    width: "100%",
    margin: "30px 0 0",
    paddingBottom: "30px",
    fontSize: "11px",
    lineHeight: "1.6",
    color: "#424530",
    fontFamily: '"Playfair Display", sans-serif !important',
    fontStyle: "italic",
    fontWeight: "bold",
    textAlign: "left",
    boxSizing: "border-box",
    "& > div": {
      fontSize: "11px !important",
      lineHeight: "1.6",
      color: "#424530 !important",
      fontFamily: '"Playfair Display", sans-serif !important',
      fontStyle: "italic !important",
      fontWeight: "bold !important",
    },
  },
  root: {
    textAlign: "left",
  },
});

const TierBenefitsTable = ({ classes, wrapperStyle }) => {
  return (
    <div className={classes.root} style={wrapperStyle}>
      <div className={classes.goldGradientBox}>
        <div style={{ backgroundColor: "#ffffff" }}>
          <table className={classes.tableWrapper}>
            <thead>
              <tr className={classes.tableHeader}>
                <th className={classes.tableHeaderCell}></th>
                <th className={classes.tableHeaderCell}>Insider</th>
                <th className={classes.tableHeaderCell}>Silver</th>
                <th className={classes.tableHeaderCell}>Gold</th>
                <th className={classes.tableHeaderCell}>Platinum</th>
              </tr>
            </thead>
            <tbody>
              {tierTableData.map((row, rowIndex) => (
                <tr key={rowIndex} className={classes.tableRow}>
                  <td className={classes.rowName}>{row.name}</td>
                  {TIER_KEYS.map((tier) => (
                    <td
                      key={tier}
                      className={
                        rowIndex % 2 === 0
                          ? classes[`${tier}Cell`]
                          : classes[`${tier}CellAlt`]
                      }
                    >
                      {row[tier] === "tick" ? (
                        <div className={classes.tickContent}>
                          <TickIcon
                            style={{
                              fontSize: "20px",
                              verticalAlign: "middle",
                            }}
                          />
                          {row[`${tier}SubText`] && (
                            <div className={classes.tickSubText}>
                              {row[`${tier}SubText`]}
                            </div>
                          )}
                        </div>
                      ) : (
                        row[tier]
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className={classes.footnotes}>
        {footnotes.map((note, index) => (
          <div key={index}>{note}</div>
        ))}
      </div>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(TierBenefitsTable);
